import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-damper-horizontal-off')
export class ObiDamperHorizontalOff extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2234_112)">
<path d="M14.8552 9.19703L20.1605 6.13402C20.6388 5.85788 21.2504 6.02176 21.5265 6.50005C21.8026 6.97834 21.6388 7.58993 21.1605 7.86607L15.8552 10.9291C16.3332 12.6452 15.6143 14.5322 14.0002 15.4642C12.3861 16.3961 10.3924 16.0751 9.14525 14.8031L3.83996 17.8661C3.36167 18.1422 2.75008 17.9783 2.47394 17.5C2.19779 17.0218 2.36167 16.4102 2.83996 16.134L8.14525 13.071C7.66719 11.3549 8.38608 9.46787 10.0002 8.53595C11.6143 7.60403 13.608 7.92496 14.8552 9.19703Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.7323 11C14.2846 11.9566 13.9568 13.1798 13.0002 13.7321C12.0436 14.2844 10.8204 13.9566 10.2682 13C9.71588 12.0435 10.0436 10.8203 11.0002 10.268C11.9568 9.71571 13.18 10.0435 13.7323 11Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.6605 5.268L14.9698 7.97618C13.4189 6.83292 11.2766 6.64431 9.50021 7.66992C7.7238 8.69554 6.81601 10.6451 7.03067 12.5598L2.33996 15.268C1.38338 15.8203 1.05563 17.0435 1.60791 18C2.1602 18.9566 3.38338 19.2844 4.33996 18.7321L9.03067 16.0239C10.5815 17.1672 12.7238 17.3558 14.5002 16.3302C16.2766 15.3046 17.1844 13.355 16.9698 11.4403L21.6605 8.7321C22.6171 8.17982 22.9448 6.95663 22.3925 6.00005C21.8402 5.04346 20.6171 4.71571 19.6605 5.268ZM20.1605 6.13402L14.8552 9.19703C13.608 7.92496 11.6143 7.60403 10.0002 8.53595C8.38608 9.46787 7.66719 11.3549 8.14525 13.071L2.83996 16.134C2.36167 16.4102 2.19779 17.0218 2.47394 17.5C2.75008 17.9783 3.36167 18.1422 3.83996 17.8661L9.14525 14.8031C10.3924 16.0751 12.3861 16.3961 14.0002 15.4642C15.6143 14.5322 16.3332 12.6452 15.8552 10.9291L21.1605 7.86607C21.6388 7.58993 21.8026 6.97834 21.5265 6.50005C21.2504 6.02176 20.6388 5.85788 20.1605 6.13402Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2234_112">
<rect width="24" height="24" fill="currentColor"/>
</clipPath>
</defs>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2234_112)">
<path d="M14.8552 9.19703L20.1605 6.13402C20.6388 5.85788 21.2504 6.02176 21.5265 6.50005C21.8026 6.97834 21.6388 7.58993 21.1605 7.86607L15.8552 10.9291C16.3332 12.6452 15.6143 14.5322 14.0002 15.4642C12.3861 16.3961 10.3924 16.0751 9.14525 14.8031L3.83996 17.8661C3.36167 18.1422 2.75008 17.9783 2.47394 17.5C2.19779 17.0218 2.36167 16.4102 2.83996 16.134L8.14525 13.071C7.66719 11.3549 8.38608 9.46787 10.0002 8.53595C11.6143 7.60403 13.608 7.92496 14.8552 9.19703Z" style="fill: var(--automation-device-primary-inverted-color)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.7323 11C14.2846 11.9566 13.9568 13.1798 13.0002 13.7321C12.0436 14.2844 10.8204 13.9566 10.2682 13C9.71588 12.0435 10.0436 10.8203 11.0002 10.268C11.9568 9.71571 13.18 10.0435 13.7323 11Z" style="fill: var(--automation-device-tertiary-inverted-color)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.6605 5.268L14.9698 7.97618C13.4189 6.83292 11.2766 6.64431 9.50021 7.66992C7.7238 8.69554 6.81601 10.6451 7.03067 12.5598L2.33996 15.268C1.38338 15.8203 1.05563 17.0435 1.60791 18C2.1602 18.9566 3.38338 19.2844 4.33996 18.7321L9.03067 16.0239C10.5815 17.1672 12.7238 17.3558 14.5002 16.3302C16.2766 15.3046 17.1844 13.355 16.9698 11.4403L21.6605 8.7321C22.6171 8.17982 22.9448 6.95663 22.3925 6.00005C21.8402 5.04346 20.6171 4.71571 19.6605 5.268ZM20.1605 6.13402L14.8552 9.19703C13.608 7.92496 11.6143 7.60403 10.0002 8.53595C8.38608 9.46787 7.66719 11.3549 8.14525 13.071L2.83996 16.134C2.36167 16.4102 2.19779 17.0218 2.47394 17.5C2.75008 17.9783 3.36167 18.1422 3.83996 17.8661L9.14525 14.8031C10.3924 16.0751 12.3861 16.3961 14.0002 15.4642C15.6143 14.5322 16.3332 12.6452 15.8552 10.9291L21.1605 7.86607C21.6388 7.58993 21.8026 6.97834 21.5265 6.50005C21.2504 6.02176 20.6388 5.85788 20.1605 6.13402Z" style="fill: var(--automation-device-tertiary-inverted-color)"/>
</g>
<defs>
<clipPath id="clip0_2234_112">
<rect width="24" height="24" fill="none"/>
</clipPath>
</defs>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-damper-horizontal-off': ObiDamperHorizontalOff;
  }
}
